import React from "react";
import { PartnerListPageInitialState, PageNewState } from ".";

export const PartnerListPageContext = React.createContext({
  pageState: PartnerListPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
